import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

// 2. Fungsi Login
export const login = async (loginData) => {
  const response = await axios.post(`${API_BASE}/auth/login`, loginData);

  if (response.data && response.data.token) {
    localStorage.setItem("token", response.data.token);
  }

  return response.data;
};

export const register = async (registerData) => {
  const response = await axios.post(`${API_BASE}/auth/register`, registerData);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem("token");
};

export const forgotPassword = async (email) => {
  const response = await axios.post(`${API_BASE}/auth/forgot-password`, { email });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await axios.post(`${API_BASE}/auth/reset-password`, { token, newPassword });
  return response.data;
};
